import React, { useState, useContext } from "react";

import { ContextNotificacoes } from "../../../services/notificacoes";
import { ContextSolicitacoes } from "../../../services/solicitacoes";
import { Spinner } from "../../StyledComponent";

import { ReactComponent as History } from "../../../assets/novosicones/notificacoes/agendamentos.svg";

import { useHistory } from "react-router-dom";

import Fases from "../Fases";

const VistoriaNaoCompareceu = ({ tema, setNotificationsModal }) => {
  const [loading, setLoading] = useState(false);

  const [
    vistoriaNaoCompareceuSelecionada,
    setVistoriaNaoCompareceuSelecionada,
  ] = useState("");

  const {
    marcarNotificacaoVistoriaNaoCompareceu,
    atualizaNotificacoes,
    setNotificationNotFoundError,
  } = useContext(ContextNotificacoes);

  const { getSolicitacao } = useContext(ContextSolicitacoes);

  const NOTIFICATIONSVISTORIANAOCOMPARECEU = JSON.parse(
    sessionStorage.getItem("notificationsVistoriaNaoCompareceu")
  );

  const history = useHistory();

  const updateNotificacoes = (id) => {
    let temp = NOTIFICATIONSVISTORIANAOCOMPARECEU.filter(
      (vistoriaNaoCompareceu) => vistoriaNaoCompareceu.Id != id
    );
    sessionStorage.setItem(
      "notificationsVistoriaNaoCompareceu",
      JSON.stringify(temp)
    );
  };

  async function redirectToSolicitations(id) {
    await marcarNotificacaoVistoriaNaoCompareceu(id);

    await atualizaNotificacoes();

    updateNotificacoes(id);

    // history.push({
    //   pathname: "/solicitacoes/nova-solicitacao",
    // });
    let resultGet = await getSolicitacao(id);
    updateNotificacoes(id);
    if (resultGet?.status === 400) {
      setNotificationNotFoundError(true);
      setLoading(false);
      setNotificationsModal(false);
    } else {
      history.push({
        pathname: "/solicitacoes/acompanhar-solicitacao",
        state: {
          solicitacao: resultGet,
        },
      });
      setLoading(false);
      setNotificationsModal(false);
    }
  }

  if (!NOTIFICATIONSVISTORIANAOCOMPARECEU?.length) return null;

  return (
    <div className="notifications__item">
      {NOTIFICATIONSVISTORIANAOCOMPARECEU?.length > 0 &&
        NOTIFICATIONSVISTORIANAOCOMPARECEU.map((notification, index) => {
          return (
            <div key={index} className="centralized-space-between">
              <div className="centralized">
                <span
                  style={{ width: "24px", height: "24px", display: "block" }}
                >
                  <History
                    style={
                      notification?.Visualizado
                        ? { fill: "#D1D1D1" }
                        : { fill: tema.primaryColor }
                    }
                  />
                </span>

                <p
                  className="notifications__item__description"
                  style={
                    notification?.Visualizado
                      ? { fill: "#D1D1D1" }
                      : { fill: tema.primaryColor }
                  }
                >
                  Você não compareceu no dia e horário agendados para a vistoria
                  da unidade {notification?.AssetName}, acesse já em minhas
                  solicitações e agende novo horário!
                </p>
              </div>
              {loading &&
              vistoriaNaoCompareceuSelecionada == notification.IdSalesForce ? (
                <Spinner />
              ) : (
                <a
                  style={{ color: tema.primaryColor, cursor: "pointer" }}
                  onClick={() => {
                    setLoading(true);
                    setVistoriaNaoCompareceuSelecionada(
                      notification.IdSalesForce
                    );
                    redirectToSolicitations(notification.IdSalesForce);
                  }}
                >
                  VISUALIZAR
                </a>
              )}
            </div>
          );
        })}
      <Fases tema={tema} setNotificationsModal={setNotificationsModal} />
    </div>
  );
};

export default VistoriaNaoCompareceu;
